/* eslint-disable no-console */
import { run, App } from '@tcc/zero';
import { getAllMeasures } from '@tcc/stopwatch';
import { logError } from '@tcc/scarecrow';

import configureStore from 'store/configureStore';
import { Provider } from 'react-redux';
import React from 'react'; // eslint-disable-line no-unused-vars
import ReactDOM from 'react-dom';
import { Router, hashHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import bootSteps from './zero/boot/config';
import routes from './routes';
import { getTCCAuthPluginUrl } from './utils/url';

// Fixes redirect issue with syncHistoryWithStore
if (window.location.hash === '') {
  window.location.hash = '/';
}

class AuthPages extends App {
  mount() {
    // configure the redux store
    const store = configureStore(hashHistory);

    // Create an enhanced history that syncs navigation events with the store
    const history = syncHistoryWithStore(hashHistory, store);

    // wrap our base component (Main) in the redux Provider and ReactIntl IntlProvider
    const baseComponents = (
      <Provider store={store}>
        <Router history={history} routes={routes} />
      </Provider>
    );

    // We just run the app on development environment as this app is deprecated
    // eslint-disable-next-line no-process-env
    return process.env.NODE_ENV !== 'production' ? ReactDOM.render(
      baseComponents,
      document.getElementById('auth-pages-react-app')
    ) : null;
  }
}

run(AuthPages, bootSteps).then(() => {
  // Keep Metric Reports for DEV Only
  // eslint-disable-next-line no-process-env
  // eslint-disable-next-line no-process-env
  if (process.env.NODE_ENV !== 'production' && console.table) {
    console.table(getAllMeasures());
  } else {
    // We are deprecating this app in favor of tcc-auth-plugin
    const url = getTCCAuthPluginUrl(window.location.href);

    // Log error to reporting service
    logError('We are deprecating this app in favor of tcc-auth-plugin', {
      referrer: document.referrer
    });

    // Redirect user
    window.location.assign(url);
  }
});
